import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaExternalLinkAlt } from "react-icons/fa";
import "./LocalInstitucional.css";

const LocalInstitucional = () => {
  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const googleMapsUrl = "https://maps.app.goo.gl/r9bpUA2riufVdLHM8";

  return (
    <section className="local-page">
      {/* Banner superior */}
      <div className="local-hero" data-aos="fade-down">
        <div className="overlay"></div>
        <div className="container text-center text-white">
          <h1 className="fw-bold">Información de Sede Principal</h1>
          <p className="lead">
            Conoce la ubicación y datos principales de nuestra institución.
          </p>
        </div>
      </div>

      {/*  Contenido principal */}
      <div className="container py-5">
        <div className="row g-4 align-items-stretch">
          {/*  Mapa */}
          <div className="col-lg-6" data-aos="fade-right">
            <div className="mini-map position-relative w-100 h-100">
              <iframe
                title="Ubicación del IESTP Gilda Liliana Ballivián Rosado"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3900.2179680028758!2d-76.9770377251729!3d-12.165558488080606!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9105b851de5dffc1%3A0xa7c420906cc5e7f8!2sIESTP%20Gilda%20Liliana%20Ballivian%20Rosado!5e0!3m2!1ses!2spe!4v1761944551910!5m2!1ses!2spe" 
                
                width="100%"
                height="100%"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>

              <a
                href={googleMapsUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="btn-mapa-flotante"
              >
                <FaExternalLinkAlt className="me-2" />
                Ver en Google Maps
              </a>
            </div>
          </div>

          {/*  Descripción */}
          <div className="col-lg-6 d-flex flex-column justify-content-center" data-aos="fade-left">
            <div>
              <h3 className="text-primary mb-4 section-subtitle">
                Información de la Sede Principal
              </h3>

              <p className="descripcion">
                El Instituto de Educación Superior Tecnológico Público{" "}
                <strong>“Gilda Liliana Ballivián Rosado”</strong> tiene su sede principal
                ubicada en el distrito de San Juan de Miraflores, Lima, Perú.
              </p>

              <ul className="info-list mb-4">
                <li>
                  <strong>Dirección:</strong> Av. Vargas Machuca N° 315 (Frente al Banco de Crédito), Urb. "San Juan", San Juan de Miraflores - Lima.
                </li>
                <li>
                  <strong>Teléfono:</strong> 01-4661035
                </li>
                <li>
                  <strong>Distrito:</strong> San Juan de Miraflores
                </li>
                <li>
                  <strong>Provincia:</strong> Lima
                </li>
                <li>
                  <strong>País:</strong> Perú
                </li>
              </ul>

              <p className="descripcion">
                Nuestra institución ofrece una variedad de programas técnicos
                diseñados para preparar a los estudiantes para el mercado laboral
                y contribuir al desarrollo socioeconómico de la región.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocalInstitucional;
